export default __webpack_public_path__ + "static/media/privacy_policy.0077f6ae.pdf";